import React from "react";
import { Product } from "@/types/general";
import { useTranslation } from "react-i18next";
import LocationsTab from "./items/LocationsTab";
import PricesTab from "./items/PricesTab/PricesTab";
import PurchaseOrdersTab from "./items/PurchaseOrdersTab";
import SaleOrdersTab from "./items/SaleOrdersTab";
import TranslationsTab from "./items/TranslationTab/TranslationTab";
import NumbersTab from "./items/NumbersTab/NumbersTab";
import { useAbility } from "@/casl.config";
import BaseTabs from "@reusables/BaseTabs";

interface ProductStepperProperties {
    informationTab: JSX.Element;
    product?: Product.Extended;
    previewMode: boolean;
}

export default function ProductStepper(props: ProductStepperProperties) {
    const { t } = useTranslation("", { keyPrefix: "products.viewEditProduct" });

    const ability = useAbility();

    return (
        <>
            <BaseTabs
                tabs={[
                    {
                        key: "information",
                        title: t("tabs.information.heading"),
                        content: props.informationTab
                    },
                    {
                        key: "translations",
                        title: t("tabs.translations.heading"),
                        content: <TranslationsTab product={props.product!} />
                    },
                    {
                        key: "prices",
                        title: t("tabs.prices.heading"),
                        content: <PricesTab product={props.product!} />
                    },
                    {
                        key: "locations",
                        title: t("tabs.locations.heading"),
                        content: <LocationsTab product={props.product} preview={props.previewMode} />,
                        hidden: props.product?.is_service || !ability.can("locations.view", "product")
                    },
                    {
                        key: "numbers",
                        title: t("tabs.numbers.heading"),
                        content: <NumbersTab product={props.product!} />
                    },
                    {
                        key: "purchaseOrder",
                        title: t("tabs.purchaseOrder.heading"),
                        content: <PurchaseOrdersTab product={props.product!} />
                    },
                    {
                        key: "saleOrder",
                        title: t("tabs.saleOrder.heading"),
                        content: <SaleOrdersTab product={props.product!} />
                    }
                ]} />
        </>
    );
}
